module.exports = __webpack_public_path__ + "static/media/multivendor-marketplace.7a46040c.png";